import { faPenToSquare } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import clsx from "clsx"

const FormContainer = ({ children, title, custCls, useIcon = false, onEdit = false, openEditForm = false }) => {
  const onClickEditBtn = () => {
    openEditForm(true)
  }

  return (
    <>
      <div className={clsx("border-[1.5px] border-[#bc9c5c] px-8 py-4", custCls)}>
        <div className={clsx({ "flex justify-between": useIcon })}>
          <span className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-2xl">{title}</span>
          {useIcon && (
            <button type="button" className="flex items-start" disabled={onEdit} onClick={onClickEditBtn}>
              <FontAwesomeIcon icon={faPenToSquare} size="xl" style={{ color: onEdit ? "#dcd6d2" : "#6e605d" }} />
            </button>
          )}
        </div>
        <div>
          {children}
        </div>
      </div>
    </>
  )
}

export default FormContainer